const categoryColors = ["#e64d7e","#e77c5e","#dee14d","#8ae371","#35e495","#38d4bb","#3ac4e0","#7498cf","#ae6bbd"]

export default categoryColors